import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.autocompleteContainer = this.element.closest('[data-controller*="autocomplete"]')
    if (!this.autocompleteContainer) return

    this.handleAutocomplete = this.autocomplete.bind(this)
    this.autocompleteContainer.addEventListener("autocomplete.change", this.handleAutocomplete)
  }

  disconnect() {
    if (this.autocompleteContainer) {
      this.autocompleteContainer.removeEventListener("autocomplete.change", this.handleAutocomplete)
    }
  }

  autocomplete(event) {
    const customerId = event.detail.value
    if (!customerId) return

    fetch(`/customers/${customerId}/check_on_request`)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`)
        return response.json()
      })
      .then((data) => {
        const elements = document.getElementsByClassName("on_request_icon")
        if (elements.length === 0) return

        if (data.on_req === true) {
          elements[0].classList.remove("hidden")
        } else {
          elements[0].classList.add("hidden")
        }
      })
      .catch((error) => {
        console.error("Failed to check on_request:", error)
      })
  }
}
